import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";

const SettingsCtx = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({ whatsapp_number: "+971565480837", email: "info@pipecogroup.com", phone: "+971565480837" });

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/settings");
      setSettings(r.data);
    } catch (e) { /* keep defaults */ }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return <SettingsCtx.Provider value={{ settings, refresh, setSettings }}>{children}</SettingsCtx.Provider>;
}

export function useSettings() {
  return useContext(SettingsCtx) || { settings: { whatsapp_number: "+97565480837" } };
}
